// The same missing-field correction mapping used by the hosted review step.
export const getTaxCorrectionStep = (accountType?: string) =>
  accountType === "Individual"
    ? "personal-information"
    : "business-information";
